import * as React from 'react';
import { Dispatch } from 'redux';
import { Link } from 'react-router-dom';
import CartTimer from '../../menu/components/cart-timer';
import Modal from '../../common/modal/modal'
import { toggleSeatmapFilters, toggleSeatmapCart } from '../../seatmap/actions/seatmap-actions';
import { removeAllSeatsFromCart } from '../../cart/actions/cart-actions';
import { ItemType } from '../../classes/item-type';
import * as PropTypes from 'prop-types';
import IAltText from '../../classes/alt-text';
import { Html } from '../../helpers/html-helpers';

import isEqual from 'react-fast-compare';

interface IAppBarProps {
    showFiltersToggle: boolean;
    headingTitle: string;
    performanceDateString: string;
    isSeatmapView: boolean;
    isExchange: boolean;
    cartSeatsCount: number;
    dispatch: any /*Dispatch<any>*/;
    altText: IAltText;
    clientSymbolSvgText: string;
    clientSymbolUrl: string;
    myAccountUrl: string;
    itemType: ItemType;
    venueName: string;
    packageProgressMessage: string;
    seatmapFiltersText: string;
    seatmapCartIsOpen: boolean;
    seatmapCartText: string;
    rightNavSvgText: string;
    rightNavUrl: string;
    itemName: string;
    itemNameRichText: string;
    itemId: number;
    modalConfirmButtonText: string;
    modalCancelButtonText: string;
    cartConflictErrorHeading: string;
    cartConflictErrorMessageText: string;
    seatmapFiltersIsOpen: boolean;
    viewFromSeatModalActive: boolean;
    cartTimerExpiringMinute: number;
    cartTimerMessaging: string;
    remainingCartTimer: number;
    cartUrl: string;
    isSyosOnlyConfig: boolean;
    cartExpiredTitle: string;
    cartExpiredMessage: string;
    cartExpiredConfirmText: string;
    disableCartExpiredPopup: boolean;
}

class AppMenu extends React.Component<IAppBarProps, { showCartConflictDialog: boolean }>{
    static contextTypes = {
        router: PropTypes.object
    }
    private headerRef: React.RefObject<HTMLDivElement>;

    constructor(props) {
        super(props);
        this.state = { showCartConflictDialog: false };
        this.headerRef = React.createRef<HTMLDivElement>();
    }

    shouldComponentUpdate(nextProps: IAppBarProps, nextState) {
        const oldValue = {
            headingTitle: this.props.headingTitle,
            performanceDateString: this.props.performanceDateString,
            isSeatmapView: this.props.isSeatmapView,
            isExchange: this.props.isExchange,
            cartSeatsCount: this.props.cartSeatsCount,
            clientSymbolSvgText: this.props.clientSymbolSvgText,
            clientSymbolUrl: this.props.clientSymbolUrl,
            myAccountUrl: this.props.myAccountUrl,
            venueName: this.props.venueName,
            seatmapCartIsOpen: this.props.seatmapCartIsOpen,
            seatmapFiltersIsOpen: this.props.seatmapFiltersIsOpen,
            viewFromSeatModalActive: this.props.viewFromSeatModalActive,
            showCartConflictDialog: this.state.showCartConflictDialog,
            remainingCartTimer: this.props.remainingCartTimer
        };

        const newValue = {
            headingTitle: nextProps.headingTitle,
            performanceDateString: nextProps.performanceDateString,
            isSeatmapView: nextProps.isSeatmapView,
            isExchange: nextProps.isExchange,
            cartSeatsCount: nextProps.cartSeatsCount,
            clientSymbolSvgText: nextProps.clientSymbolSvgText,
            clientSymbolUrl: nextProps.clientSymbolUrl,
            myAccountUrl: nextProps.myAccountUrl,
            venueName: nextProps.venueName,
            seatmapCartIsOpen: nextProps.seatmapCartIsOpen,
            seatmapFiltersIsOpen: nextProps.seatmapFiltersIsOpen,
            viewFromSeatModalActive: nextProps.viewFromSeatModalActive,
            showCartConflictDialog: nextState.showCartConflictDialog,
            remainingCartTimer: nextProps.remainingCartTimer
        };

        return !isEqual(oldValue, newValue);
    }

    componentDidUpdate(prevProps: IAppBarProps) {
        if(prevProps.isSeatmapView !== this.props.isSeatmapView) {
            this._measureHeader();
        }
    }

    componentDidMount() {
        this._measureHeader();
    }

    render() {
        const useTagBackicon = '<use xlink:href="#icon-arrow-left" />';
        const clientSvgAltText = this.props.altText !== null ? (this.props.altText.clientSvgLogo ? this.props.altText.clientSvgLogo : "") : "";
        const clientSymbolSvg = `<title id="clientSymbolSvg">${clientSvgAltText}</title>` + this.props.clientSymbolSvgText;
        const cartSvg = `<svg aria-hidden="true" focusable="false" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 27 24""><path d="M24.5199 14.1243L26.7147 4.37433C26.8731 3.67036 26.3432 3 25.6281 3H7.3918L6.96624 0.899531C6.86019 0.375984 6.40389 0 5.87456 0H1.11429C0.498875 0 0 0.503672 0 1.125V1.875C0 2.49633 0.498875 3 1.11429 3H4.35885L7.62037 19.0985C6.84009 19.5516 6.31429 20.401 6.31429 21.375C6.31429 22.8248 7.47834 24 8.91429 24C10.3502 24 11.5143 22.8248 11.5143 21.375C11.5143 20.6403 11.215 19.9765 10.7332 19.5H20.4668C19.985 19.9765 19.6857 20.6403 19.6857 21.375C19.6857 22.8248 20.8498 24 22.2857 24C23.7217 24 24.8857 22.8248 24.8857 21.375C24.8857 20.3357 24.2873 19.4376 23.4195 19.0123L23.6757 17.8743C23.8342 17.1704 23.3042 16.5 22.5891 16.5H10.1269L9.82299 15H23.4333C23.9536 15 24.4046 14.6365 24.5199 14.1243Z" /></svg>`;
        const filtersSvg = `<svg aria-hidden="true" focusable="false" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 18"><path d="M17,6c1.7,0,3-1.3,3-3s-1.3-3-3-3c-1.3,0-2.4,0.8-2.8,2H0v2h14.2C14.6,5.2,15.7,6,17,6z M17,2c0.6,0,1,0.4,1,1s-0.4,1-1,1 s-1-0.4-1-1S16.4,2,17,2z M7,6C5.7,6,4.6,6.8,4.2,8H0v2h4.2c0.4,1.2,1.5,2,2.8,2s2.4-0.8,2.8-2H20V8H9.8C9.4,6.8,8.3,6,7,6z M7,10 c-0.6,0-1-0.4-1-1s0.4-1,1-1s1,0.4,1,1S7.6,10,7,10z M17,12c-1.3,0-2.4,0.8-2.8,2H0v2h14.2c0.4,1.2,1.5,2,2.8,2c1.7,0,3-1.3,3-3 S18.7,12,17,12z M17,16c-0.6,0-1-0.4-1-1s0.4-1,1-1s1,0.4,1,1S17.6,16,17,16z"/></svg>`;
        const xSvg = `<svg class="close-filters-icon"><use xlink:href="#icon-close" /></svg>`;

        const seatMapBackButton = (
            this.props.isExchange ?
                <a aria-label="Click here to go back to My Account" href={this.props.myAccountUrl}>
                    <svg className="header-back-icon" dangerouslySetInnerHTML={{ __html: useTagBackicon }} />
                </a>
                :
                <a aria-label="Click here to go back to filters" href="/" onClick={this._backButtonCartConflictClick.bind(this)}>
                    <svg className="header-back-icon" dangerouslySetInnerHTML={{ __html: useTagBackicon }} />
                </a>
        );

        const filtersBackButtonSvg = (
            this.props.clientSymbolUrl !== null && this.props.clientSymbolUrl !== "" ?
                <a href={this.props.clientSymbolUrl} target="_top" className="header-logo-link">
                    <svg className="header-logo" aria-labelledby="clientSymbolSvg" dangerouslySetInnerHTML={{ __html: clientSymbolSvg }} />
                </a>
                :
                <svg className="header-logo" aria-labelledby="clientSymbolSvg" dangerouslySetInnerHTML={{ __html: clientSymbolSvg }} />
        );

        const showCartCount = this.props.cartSeatsCount > 0;

        return (
            <header role="banner" className={` ${this.props.viewFromSeatModalActive ? 'header-container-viewfromseat' : ''}` + (this.state.showCartConflictDialog ? ' modal-active' : '')}>

                {this.props.remainingCartTimer != null ?
                    <CartTimer cartTimerMessaging={this.props.cartTimerMessaging}
                        cartUrl={this.props.cartUrl}
                        cartTimerExpiringMinute={this.props.cartTimerExpiringMinute}
                        remainingCartTimer={this.props.remainingCartTimer}
                        cartExpiredTitle={this.props.cartExpiredTitle}
                        cartExpiredMessage={this.props.cartExpiredMessage}
                        cartExpiredConfirmText={this.props.cartExpiredConfirmText}
                        disableCartExpiredPopup={this.props.disableCartExpiredPopup}
                    />
                    : null
                }

                <div className="header-container" ref={this.headerRef}>
                    <div className="header-info">
                        {
                            this.props.isSeatmapView && !this.props.isSyosOnlyConfig ?
                                seatMapBackButton
                                : filtersBackButtonSvg
                        }
                        {
                            this.props.isSyosOnlyConfig && this.props.rightNavSvgText !== null && this.props.rightNavSvgText.length > 0 ?
                                this.props.rightNavUrl ?
                                    <a href={this.props.rightNavUrl} target="_top" aria-labelledby="title">
                                        {
                                            !!this.props.altText.rightNavSymbolAltText &&
                                            <span className="visually-hidden">
                                                {this.props.altText.rightNavSymbolAltText}
                                            </span>
                                        }
                                        <div className="header-logo" dangerouslySetInnerHTML={{ __html: this.props.rightNavSvgText }} ></div>
                                    </a>
                                    :
                                    <div className="header-logo" dangerouslySetInnerHTML={{ __html: this.props.rightNavSvgText }} ></div>
                                : null
                        }
                        <div>
                            <h1 className="header-performance" dangerouslySetInnerHTML={{
                                __html: this.props.itemType === ItemType.Super && this.props.isSeatmapView ? this.props.venueName :
                                    this.props.headingTitle
                            }} />
                        </div>
                    </div>

                    {
                        this.props.isSeatmapView ?
                            <>
                                <div className="header-filters">
                                    <button type="button" className="header-filters-link" onClick={(evt) => this._toggleSeatmapCart(evt)}>
                                        <span className="caption-paragraph"><strong>{this.props.seatmapCartText}</strong></span>
                                        <div className={this.props.seatmapCartIsOpen ? "header-filters-filter-icon" : "header-filters-filter-icon"} dangerouslySetInnerHTML={{ __html: cartSvg }} ></div>
                                        {showCartCount && <span className="cart-icon-amount" id="cartAmountIcon">{this.props.cartSeatsCount}</span>}
                                    </button>

                                    {
                                        this.props.showFiltersToggle ?
                                            <button type="button" className="header-filters-link" onClick={(evt) => this._toggleSeatmapFilters(evt)}>
                                                <span className="caption-paragraph"><strong>{this.props.seatmapFiltersText}</strong></span>
                                                <div className={this.props.seatmapFiltersIsOpen ? "header-filters-filter-icon" : "header-filters-filter-icon"} dangerouslySetInnerHTML={{ __html: filtersSvg }} ></div>
                                            </button>
                                            : null
                                    }

                                </div>

                            </>
                            :
                            this.props.rightNavSvgText !== null ?
                                this.props.rightNavUrl ?
                                    <a href={this.props.rightNavUrl} target="_top">
                                        {
                                            !!this.props.altText.rightNavSymbolAltText &&
                                            <span className="visually-hidden">
                                                {this.props.altText.rightNavSymbolAltText}
                                            </span>
                                        }
                                        <div className="header-right-icon" dangerouslySetInnerHTML={{ __html: this.props.rightNavSvgText }} ></div>
                                    </a>
                                    :
                                    <div className="header-right-icon" dangerouslySetInnerHTML={{ __html: this.props.rightNavSvgText }} ></div>
                                : null
                    }

                    {this.state.showCartConflictDialog ?
                        <Modal modalKey="reserve result" isError={false} title={this.props.cartConflictErrorHeading}
                            message={this.props.cartConflictErrorMessageText}
                            confirmFunction={this._proceedToFilters.bind(this)}
                            confirmString={this.props.modalConfirmButtonText}
                            cancelFunction={this._closeDialog.bind(this)}
                            closeFunction={this._closeDialog.bind(this)}
                            cancelString={this.props.modalCancelButtonText}
                        />
                        : null
                    }
                </div>
            </header>
        );
    }

    _backButtonCartConflictClick(e) {
        e.preventDefault();
        if (this.props.cartSeatsCount === 0) {
            this._proceedToFilters();
        } else {
            this.setState({ showCartConflictDialog: true });
        }
    }

    _closeDialog() {
        this.setState({ showCartConflictDialog: false });
    }

    _proceedToFilters() {
        this.setState({ showCartConflictDialog: false });
        this.props.dispatch(removeAllSeatsFromCart(this.props.itemId));
        this.context.router.history.push("/filters");
    }

    _toggleSeatmapFilters(evt) {
        evt.preventDefault();

        this.props.dispatch(toggleSeatmapFilters());
    }

    _toggleSeatmapCart(evt) {
        evt.preventDefault();

        this.props.dispatch(toggleSeatmapCart());
    }

    _measureHeader() {
        if (this.headerRef?.current) {
            setTimeout(() => {
                const headerHeight = this.headerRef.current.offsetHeight;
                document.body.style.setProperty('--header-height', `${headerHeight}px`);
            }, 0);
        }
    }
}

function isHtmlPrompt(message: string) {
    if (message === null)
        return false;
    return message.substr(0, 4) === "<div";
}

export default AppMenu;